/**
 * Dynamic Favicon Plugin
 * 
 * Fetches favicon URL from the API branding endpoint and applies it to the page.
 * This runs client-side to dynamically update the favicon based on BackOffice settings.
 */
export default defineNuxtPlugin(async () => {
    // Only run on client-side
    if (import.meta.server) return

    const config = useRuntimeConfig()
    const apiBase = config.public.apiBase

    try {
        // Fetch branding data
        const data = await $fetch<{ favicon?: string }>(`${apiBase}/oxoweb/school/branding`)

        if (data?.favicon) {
            // Find existing favicon link or create new one
            let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement | null

            if (!link) {
                link = document.createElement('link')
                link.rel = 'icon'
                document.head.appendChild(link)
            }

            link.href = data.favicon
        }
    } catch (e) {
        console.warn('[Favicon Plugin] Could not fetch branding:', e)
    }
})
